import { environment } from '@environment';
import { Pipe, PipeTransform } from '@angular/core';

type BrandDetail = { brand_id: number; brand_name: string; total_cost: number; quantity: number };

@Pipe({
    name: 'brandState',
    standalone: true
})
export class BrandStatePipe implements PipeTransform {
    constructor() {}

    transform(brands: BrandDetail[], brandState: Set<number>): BrandDetail[] {

        if (!brandState.size) {
            return;
        }
        
        const primaryBrandId = environment.brand.id;
        const filteredBrands = brands.filter(brand => brandState.has(brand.brand_id));
        const primaryBrand = filteredBrands.filter((brand) => brand.brand_id === primaryBrandId);
        const otherBrands = filteredBrands.filter((brand) => brand.brand_id !== primaryBrandId);

        // Return brands with the primary brand placed at the end, as we want to show add-ons last
        return otherBrands.concat(primaryBrand);
    }
}
